/**
 * Guards report metrics so only real, measured data is surfaced.
 *
 * The analysis agent sometimes fills in benchmark/industry estimates
 * (e.g. "~72% (iOS music benchmark)", "$37 (est.)", "9.5% — no actuals")
 * when actuals are unavailable. Those must never be shown as if they were
 * real numbers — callers should fall back to a dash instead.
 */
export const ESTIMATE_MARKER = /benchmark|no actuals?|estimat|assumed|industry|~|approx|\bn\/?a\b|\best\.?\b/i;

/** Returns the trimmed string if it looks like real data, otherwise null. */
export function realValue(v: unknown): string | null {
  if (v == null) return null;
  const s = String(v).trim();
  if (!s || ESTIMATE_MARKER.test(s)) return null;
  return s;
}
